<div class="wrapper-reponsive">
    <!-- Start màn 7 -->
    <div class="tlt-green-row mt-3">
        {{'STR_MEDICAL_EXAM_RESERVATION' | translate}}
    </div>
    <div class="content-box mt-2 mb-3 p-3" *ngIf="typeMode !== 3">
        <div class="process-step">
            <p>Step</p>
            <ul>
                <li class="active">
                    <div class="circle">
                        <span class="num">1</span>
                    </div>
                </li>
                <li class="active">
                    <div class="circle">
                        <span class="num">2</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">3</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">4</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">5</span>
                    </div>
                </li>
                <li>
                    <div class="circle">
                        <span class="num">6</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="content-box mt-2 mb-2">
        <div class="tlt-border mb-3">
            {{'STR_INSURANCE_INF_INPUT' | translate}}
        </div>
        <p class="p-2">
            {{'STR_EXPLANATION_INSURANCE_INPUT' | translate}}
        </p>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">
                    {{'STR_INSURER_NUM2' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input type="text" class="form-control" [(ngModel)]="objRsv.InsurerNum" maxlength="8" numberonly id="InsurerNum"
                    numberForm [ngClass]="{'error-border': isInsurerNum && util.isNullOrEmpty(objRsv.InsurerNum)}" autocomplete="off"
                    (keydown)="changeInsurerNum()" (input)="objRsv.InsurerNum = $event.target.value.trim()">
                <span *ngIf="isInsurerNum && util.isNullOrEmpty(objRsv.InsurerNum)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_INSURER_NUM2')])}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_INSURANCE_CARD_SIGN' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input type="text" class="form-control" [(ngModel)]="objRsv.InsuranceCardSign" maxlength="20" id="InsuranceCardSign"
                    [ngClass]="{'error-border': isInsuranceCardSign && util.isNullOrEmpty(objRsv.InsuranceCardSign)}" autocomplete="off"
                    (keydown)="changeInsuranceCardSign()" (input)="objRsv.InsuranceCardSign = $event.target.value.trim()">
                <span *ngIf="isInsuranceCardSign && util.isNullOrEmpty(objRsv.InsuranceCardSign)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_INSURANCE_CARD_SIGN')])}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_INSURANCE_CARDNUM' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <!-- 20241204 modify #23731 start -->
                <!-- <input type="text" class="form-control" [(ngModel)]="objRsv.InsuranceCardNum" maxlength="10" numberonly id="InsuranceCardNum"
                    numberForm (input)="objRsv.InsuranceCardNum = $event.target.value.trim()" [ngClass]="{'error-border': isInsuranceCardNum && util.isNullOrEmpty(objRsv.InsuranceCardNum)}" autocomplete="off"
                    (keydown)="changeInsuranceCardNum()"> -->
                <input type="text" class="form-control" [(ngModel)]="objRsv.InsuranceCardNum" maxlength="10" id="InsuranceCardNum"
                    (keydown)="numberAndLetterOnly($event)" 
                    (input)="onInput($event)"
                    [ngClass]="{'error-border': isInsuranceCardNum && util.isNullOrEmpty(objRsv.InsuranceCardNum)}">    
                <!-- 20241204 modify #23731 end -->         
                <span *ngIf="isInsuranceCardNum && util.isNullOrEmpty(objRsv.InsuranceCardNum)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_INSURANCE_CARDNUM')])}}
                </span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">
                    {{'STR_INSURANCE_CARD_BRANCHNUM' | translate}}
                </div>
                <p class="p-2">
                    {{'STR_EXPLAIN_BRANCH_NUMBER' | translate}}
                </p>
                <input type="text" class="form-control" [(ngModel)]="objRsv.InsuranceCardBranchNum" maxlength="2"
                    numberonly numberForm id="InsuranceCardBranchNum" autocomplete="off">
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_PERSONAL_FAMILY_DIV' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <div class="row mt-2">
                    <div class="col-6">
                        <label class="custom-radio">{{'STR_PERSON' | translate}}
                            <input type="radio" name="radio" id="1" [(ngModel)]="objRsv.PersonFamilyDiv" [value]="'1'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="col-6">
                        <label class="custom-radio">{{'STR_FAMILY' | translate}}
                            <input type="radio" name="radio" id="2" [(ngModel)]="objRsv.PersonFamilyDiv" [value]="'2'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <span *ngIf="isPersonFamilyDiv && util.isNullOrEmpty(objRsv.PersonFamilyDiv)" class="text-error">
                    {{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED'),
                    trans.instant('STR_PERSONAL_FAMILY_DIV')])}}
                </span>
            </div>
        </div>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_SAMPLE_UNION_HEALTH_INSURANCE' | translate}}
            </div>
            <details>
                <summary>
                    <div class="mark-carret"></div>
                </summary>
                <div class="p-2 text-center img-insurance">
                    <img src="../../../../assets/img/insurance-health.png" alt="">
                </div>
            </details>
        </div>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_SAMPLE_HEALTH_INSURANCE_ASSOCIATION' | translate}}
            </div>
            <details>
                <summary>
                    <div class="mark-carret"></div>
                </summary>
                <div class="p-2 text-center img-insurance">
                    <img src="../../../../assets/img/insurance-association.png" alt="">
                </div>
            </details>
        </div>
        <div class="box-common mb-2">
            <div class="tlt-dot m-0">
                {{'STR_SAMPLE_NATIONAL_HEALTH_INSURANCE' | translate}}
            </div>
            <details>
                <summary>
                    <div class="mark-carret"></div>
                </summary>
                <div class="p-2 text-center img-insurance">
                    <img src="../../../../assets/img/insurance-national-health.png" alt="">
                </div>
            </details>
        </div>
        <p class="mb-4 p-2" style="background-color: #FFF2CC;">{{'STR_SAMPLE_GUIDE' | translate}}</p>
        <div class="text-center mt-2">
            <div class="lst-button-flex">
                <button class="btn btn-common btn-bg-yellow mr-2 ml-2 mb-2" (click)="ButtonBack()">
                    {{'STR_BTN_BACK' | translate}}
                </button>
                <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" *ngIf="typeMode === 1" (click)="ButtonNextOrEdit()">
                    {{'STR_BTN_THE_NEXT' | translate}}
                </button>
                <button class="btn btn-common btn-bg-green mr-2 ml-2 mb-2" *ngIf="typeMode !== 1" (click)="ButtonNextOrEdit()" [disabled]="!checkChangeData()">
                    {{'STR_BTN_EDIT' | translate}}
                </button>
            </div>
        </div>
    </div>
    <!-- End màn 7 -->
</div>
<ng-template #popUp0304>
    <!-- Modal -->
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{'STR_BUSINESS_GROUP_SELECT' | translate}}</h5>
        </div>
        <div class="modal-body">
            <p>
                {{'STR_SELECT_ORG_NOTE' | translate}}
            </p>
            <div class="box-common mt-4 mr-4 ml-4" [ngClass]="{'mb-2': isShowSelectCoCode, 'mb-4': !isShowSelectCoCode}">
                <div class="tlt-dot m-0">
                    {{'STR_COOP_ORG' | translate}}
                </div>
                <div class="table-common scrollbar table-select-course p-0">
                    <table class="table table-bordered table-striped">
                        <caption class="d-none"></caption>
                        <thead class="d-none">
                            <tr>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let it of lstCourse; let i = index">
                                <td [ngClass]="{'active': it.Checked}">
                                    <label class="custom-radio">
                                        {{it.CoName}}
                                        <input type="radio" name="radioSelectCode" (click)="changeSelectCoCode(it)" [(ngModel)]="objSelectCode" [value]="i">
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="ml-4 mr-4 mb-2" *ngIf="isShowSelectCoCode">
                <span class="text-error mt-0">{{util.stringFormat([trans.instant('MESS_CMN_ERR_MISS_SELECT_REQUIRED'), trans.instant('STR_COOP_ORG')])}}</span>
            </div>
            <div class="text-right">
                <button class="btn btn-common w150 btn-bg-yellow" (click)="ButtonCancel0304()">
                    {{'STR_BTN_CANCEL' | translate}}
                </button>
                <button class="btn btn-common w150 btn-bg-green ml-3" (click)="ButtonSelectCoCode()">
                    {{'STR_SELECT_BTN' | translate}}
                </button>
            </div>
        </div>
    </div>
    <!-- End màn 13 -->
</ng-template>
